/* eslint-disable jira/naming/disallow-filenames */
import queryString from 'query-string';
import { fg } from '@atlassian/jira-feature-gating';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type RouterContext,
	type RouterDataContext,
	type ResourceStoreContext,
	type RouteResource,
} from '@atlassian/react-resource-router';

export const RESOURCE_TYPE_JIRA_SEARCH = 'RESOURCE_TYPE_JIRA_SEARCH';
export type JiraSearchResponse = {
	url: string;
};

export const jiraSearchResource: RouteResource<JiraSearchResponse | null> =
	createResource<JiraSearchResponse | null>({
		type: RESOURCE_TYPE_JIRA_SEARCH,
		// Key per resolved query (the params getData fetches on). A constant key lets a
		// debounced prefetch for one query be reused by react-resource-router for a
		// different submit, landing the user on a stale search. Gated with that prefetch.
		getKey: ({ query }: RouterContext) =>
			fg('quick_find_typing_debounce_prefetch')
				? `search-${queryString.stringify({ ...query })}`
				: 'search',
		getData: ({ query }: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
			const { atlassianAccountId } = tenantContext;

			if (!atlassianAccountId || !query?.searchString) {
				return null;
			}

			// ideally to calculate NIN search relevance while transitioning from the dialog, we would want to pass in multiple query params.
			const queryStr = queryString.stringify({ ...query });

			return fetchJson(`/rest/navigation/4/quicksearch?${queryStr}`);
		},
		isBrowserOnly: true,
	});
